/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Device_WatchInputs */

const en_why_listening_device_watch = /** @type {(inputs: Why_Listening_Device_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On your watch`)
};

const es_why_listening_device_watch = /** @type {(inputs: Why_Listening_Device_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En tu reloj`)
};

/**
* | output |
* | --- |
* | "On your watch" |
*
* @param {Why_Listening_Device_WatchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_device_watch = /** @type {((inputs?: Why_Listening_Device_WatchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Device_WatchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_device_watch(inputs)
	return en_why_listening_device_watch(inputs)
});